<script setup lang="ts">
import { useMediaUrl } from '@/composables/useMediaUrl'

/**
 * Resolves an upload path for use inside lists, where a composable can't be
 * called per item: `<MediaUrl :src="path" v-slot="{ url }"><img :src="url"></MediaUrl>`.
 * `url` is empty until a private file's download link has loaded.
 */
const props = defineProps<{ src?: string | null }>()
const url = useMediaUrl(() => props.src)
</script>

<template>
  <slot :url="url" />
</template>
